import { render } from "./site.vue?vue&type=template&id=0ddb39f9&lang=pug"
import script from "./site.vue?vue&type=script&lang=js"
export * from "./site.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__